import { noop } from '@utils/noop';
import { Dispatch, createContext, useContext } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { ObjectSchema, date, object, string } from 'yup';

export type SetupCampaignFormState = {
  description: string;
  startDate: Date | string | null;
  endDate: Date | string | null;
  status: string;
};

export const setupCampaignFormStateDefault: SetupCampaignFormState = {
  description: '',
  startDate: '',
  endDate: '',
  status: '',
};

export const setupCampaignSchemaDefault: ObjectSchema<Partial<SetupCampaignFormState>> =
  object<SetupCampaignFormState>().shape({
    description: string().required('description is required field'),
    startDate: date().required('start date is required field'),
    endDate: date().required('end date is required field'),
    status: string().required('status is required field'),
  });

type SetupCampaignFormContextType = {
  schema: ObjectSchema<Partial<SetupCampaignFormState>>;
  setSchema: Dispatch<ObjectSchema<Partial<SetupCampaignFormState>>>;
  methods?: UseFormReturn<SetupCampaignFormState>;
};

const createCampaignFormContextDefault = {
  schema: setupCampaignSchemaDefault,
  setSchema: noop,
} satisfies SetupCampaignFormContextType;

export const SetupCampaignFormContext = createContext<SetupCampaignFormContextType>(
  createCampaignFormContextDefault
);

export const useSetupCampaignForm = () => {
  const { methods } = useContext(SetupCampaignFormContext);
  if (!methods) {
    throw new Error('SetupCampaignFormContext is empty');
  }

  return methods;
};

export const useManageSetupCampaignSchema = () => {
  const { setSchema } = useContext(SetupCampaignFormContext);

  return { setSchema };
};
